// Page for WXG images
import React from 'react';
import { getFileType, isTrainingMode } from '../helpers';

export const WXG = ({ data }) => {
  const images = data?.wxgImages ?? data?.Image_List?.[0]?.Image ?? [];

  const trainingMode = isTrainingMode();

  return (
    <div className='weather-images'>
      {images.map((image, i) => {
        const fileUrl = image?.fileUrl;
        const base64 = image?.base64;
        const type = image?.type || 'png';
        const fileName = image?.fileName || 'WXG Image';

        // In training mode, only use base64 images
        if (trainingMode && !base64) {
          return (
            <span style={{ textAlign: 'center', marginTop: 10 }} key={i}>
              Image not available in training mode
            </span>
          );
        }

        const src = base64 ? `data:image/${type};base64,${base64}` : fileUrl;

        if (!src) {
          return (
            <span style={{ textAlign: 'center', marginTop: 10 }} key={i}>
              No Image Found
            </span>
          );
        } else {
          // Skip rendering PDFs
          if (!base64 && getFileType(fileUrl) === 'pdf') {
            return <></>;
          }

          // Render image
          return <img key={i} src={src} alt={fileName} />;
        }
      })}
    </div>
  );
};
